"use client";
import Image from "next/image";
import Airplane from "../../../public/airport/airplane.svg";
import Link from "next/link";

const Airports = ({ filteredAirports }) => {
  return (
    <div>
      <div className="mx-auto max-w-7xl py-10 px-4">
        <div className="text-center">
          <h1 className="text-3xl font-bold secondary">
            Travel to and from your desired Airport with{" "}
            <span className="text-[#D5AF34]">
              <a href="/">Prestige Ride</a>
            </span>
          </h1>
          <p className="mt-2 updatedparapremu">
            Whether you’re arriving at the airport to attend a conference or
            departing for a special occasion, our professional team guarantees a
            stress free journey. Select your airport, provide the details of
            your flights and rest assured that our{" "}
            <a id="highlight" href="/services/chauffeur-service">
              {" "}
              Chauffeur
            </a>{" "}
            will handle the complexities of your transportation. Safe travels!
          </p>
        </div>
        <div className="mt-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredAirports?.map((item) => (
              <Link href={`/airports/${item.href}`}>
                <article
                  className="hover flex max-w-xl flex-col items-start justify-between rounded-[19px] airport-blogs"
                  style={{ border: "1px solid #2B3252" }}
                  key={item?.id}
                >
                  <div className="relative flex items-center gap-x-4">
                    <div
                      style={{ borderRight: "1px solid #2B3252" }}
                      className="flex flex-col justify-center items-center px-3 py-1"
                    >
                      <Image
                        src={Airplane}
                        alt={item?.alt}
                        title={item?.tle}
                        className="h-7 w-7"
                      />
                      <p className="font-bold text-[#2B3252]">{item?.code}</p>
                    </div>
                    <div className="">
                      <h3 className="text-[#2B3252] pr-3 leading-6">
                        {item?.name}
                      </h3>
                    </div>
                  </div>
                </article>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Airports;
